"use client";

import React from "react";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Autoplay } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/free-mode";

function OnTheJobTraining({ course, courseSections }) {
  // Raw items from API — support multiple shapes
  const rawItems =
    courseSections?.OnTheJobTraining ||
    courseSections?.attributes?.OnTheJobTraining ||
    course?.OnTheJobTraining ||
    [];

  // Normalise API data -> flat slide objects
  const slides =
    rawItems
      ?.map((item) => {
        const media = item?.OnTheJobDescriptionImage;

        if (!media) return null;

        // Prefer formatted URLs if available
        const src =
          media.formats?.medium?.url ||
          media.formats?.large?.url ||
          media.formats?.small?.url ||
          media.url;

        if (!src) return null;

        return {
          id: media.id || media.documentId || index,
          src,
          alt:
            media.alternativeText ||
            item.OnTheJobTrainingImageText ||
            "On-the-job training image",
          caption:
            item.OnTheJobTrainingImageText ||
            media.caption ||
            "",
        };
      })
      .filter(Boolean) || [];

  const description = course?.OnTheJobTrainingDescription || "";

  if (!slides || slides.length === 0) return null;

  // Duplicate for seamless marquee
  const marqueeItems = [...slides, ...slides];

  return (
    <div className="page-container mb-[50px] lg:mb-[70px]">
      {/* Header */}
      <div className="mt-[50px] md:mt-[80px] xl:mt-[100px]">
        <h2 className="mb-[12px]">On-the-Job Learning</h2>
        <p className="text-black mb-[32px] md:mb-[48px] w-full md:w-[80%] xl:w-[80%]">
          {description}
        </p>
      </div>

      {/* Marquee Slider */}
      <div className="relative">
          <div className="w-full">
          {/* Debug: show detected slides count */}

          {slides.length > 0 ? (
            <Swiper
              modules={[FreeMode, Autoplay]}
              spaceBetween={16}
              slidesPerView={1.15}
              freeMode={false}
              loop={true}
              autoplay={{ delay: 2500, disableOnInteraction: false, pauseOnMouseEnter: true }}
              speed={800}
              breakpoints={{
                640: { slidesPerView: 1.2 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
              }}
              className="py-2"
            >
              {slides.map((item, index) => (
                <SwiperSlide key={`${item.src}-${item.id || index}-${index}`} className="w-auto">
                  <div className="relative overflow-hidden group transition-transform duration-700 hover:scale-105">
                    <div className="relative w-full h-44 md:h-64 lg:h-72 overflow-hidden shadow-lg">
                      <Image
                        src={item.src}
                        alt={item.alt}
                        fill
                        sizes="(max-width: 425px) 70vw ,(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
                        className="object-cover"
                        loading="lazy"
                      />
                      <div
                        className="absolute inset-0 z-10 opacity-100 md:opacity-100 lg:opacity-0 md:group-hover:opacity-100 transition-opacity duration-700"
                        style={{
                          background:
                            "linear-gradient(180deg, rgba(8, 30, 45, 0) 0%, #081E2D 100%)",
                        }}
                      />
                    </div>

                    {item.caption && (
                      <div className="absolute bottom-2 md:bottom-4 left-4 right-4 z-20 text-white md:opacity-100 lg:opacity-0 md:group-hover:opacity-100 transition-opacity duration-700">
                        <p className="text-[13px] md:text-[14px] opacity-90 w-full break-words leading-tight line-clamp-2 overflow-hidden">
                          {item.caption}
                        </p>
                      </div>
                    )}
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <div className="text-sm text-gray-500 p-4">No items found for On-The-Job Training.</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default OnTheJobTraining;
